/* eslint-disable jsx-a11y/label-has-associated-control */
import { Formik, FormikHelpers } from "formik";
import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import {
  LuCalendarRange,
  LuClock,
  LuFileText,
  LuUsers,
} from "react-icons/lu";

import moment from "moment";

import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";

import api from "../../../../services/api";

import { useAuth } from "../../../../hooks/auth";
import { useToast } from "../../../../hooks/toast";
import useResponsaveis from "../../../../hooks/useResponsaveis";
import { GrupoResponsaveis } from "../../../../utils/responsaveis";

import {
  DateFilter,
  DateFilterValue,
  Field,
  FilterStyles,
  Section,
} from "../../../../components/FilterKit";

import { Container } from "../styles";

interface SearchData {
  proc_cod_cliente: number;
  inCharge: string;
  referenceId: number;
  description: string;
  hourType: string;
  proc_tipo: string;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
}

const SearchPendingHour: React.FC = () => {
  const { addToast } = useToast();
  const { user } = useAuth();
  const history = useHistory();

  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD hh:mm:ss");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD hh:mm:ss");

  const [customerId, setCustomerId] = useState("");
  const [referenceId, setReferenceId] = useState(0);
  const [hourType, setHourType] = useState("normais");
  const [description, setDescription] = useState("");

  const [initialRegistrationDate, setInitialRegistrationDate] = useState<
    string | Date | Date[] | null
  >(new Date(startOfMonth));
  const [finalRegistrationDate, setFinalRegistrationDate] = useState<
    string | Date | Date[] | null
  >(new Date(endOfMonth));

  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [sectorOptions, setSectorOptions] = useState([{}]);
  const [referenceOptions, setReferenceOptions] = useState([{}]);

  let loggedUserLevel = "";
  let loggedUserLevelNumber = 0;
  let loggedUserId = 0;
  // const accessData = sessionStorage.getItem('@Jurisnet:access');
  const accessData = localStorage.getItem("@Jurisnet:access");

  if (typeof accessData === "string") {
    const access = JSON.parse(accessData);
    loggedUserLevel = access.nivelusuario;
    loggedUserId = Number(access.usuario_logado);
  }

  if (user.user_level > 0) {
    loggedUserLevelNumber = user.user_level;
  }

  let userTypeDefinition = "";
  switch (loggedUserLevel) {
    case "Administrador":
      userTypeDefinition = "global|0";
      break;
    case "Advogado":
      userTypeDefinition = `adv|${loggedUserId}`;
      break;
    case "Assistente":
      userTypeDefinition = `adm|${loggedUserId}`;
      break;
    default:
      userTypeDefinition = "global|0";
      break;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [inCharge, setInCharge] = useState<any>(userTypeDefinition);
  const [dateFilterType, setDateFilterType] = useState("data");

  const [initialDesfechoDate, setInitialDesfechoDate] = useState<
    string | Date | Date[] | null
  >(null);
  const [finalDesfechoDate, setFinalDesfechoDate] = useState<
    string | Date | Date[] | null
  >(null);

  const validationSchema = null;

  const hourTypeOptions = [
    { name: "Normais", value: "normais", style: "font-size: small;" },
    { name: "Pendentes", value: "pendentes", style: "font-size: small;" },
  ];

  useEffect(() => {
    (async () => {
      await api.get("/lawsuits/references/show/all").then((response) => {
        referenceOptions.push({
          name: "Padrão",
          value: 0,
        });
        response.data.map(
          (reference: {
            horas_referencia_id: number;
            horas_referencia_nome: string;
          }) =>
            referenceOptions.push({
              name: reference.horas_referencia_nome,
              value: reference.horas_referencia_id,
            })
        );
      });
      referenceOptions.splice(0, 1);
      setReferenceOptions(referenceOptions);
    })();
  }, [referenceOptions]);

  useEffect(() => {
    (async () => {
      await api.get("customers/show/all").then((response) => {
        response.data.map(
          (customer: { cliente_id: number; cliente_nome: string }) =>
            customersOptions.push({
              name: customer.cliente_nome,
              value: customer.cliente_id,
            })
        );
      });
      customersOptions.splice(0, 1);

      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  useEffect(() => {
    (async () => {
      await api
        .get("/management/attorneys/show/inchargelawsuits/attorneys")
        .then((response) => {
          if (response.data.length > 0) {
            sectorOptions.push({
              name: "Todos",
              value: "all",
            });
            response.data.map((sector: { setor_adv: string }) =>
              sectorOptions.push({
                name: sector.setor_adv,
                value: sector.setor_adv,
              })
            );
          }
        });

      await api
        .get("/management/attorneys/show/inchargelawsuits/others")
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((sector: { setor_adm: string }) => {
              if (sectorOptions.indexOf(sector.setor_adm) === -1) {
                sectorOptions.push({
                  name: sector.setor_adm,
                  value: sector.setor_adm,
                });
              }
            });
          }
        });

      sectorOptions.splice(0, 1);
      setSectorOptions(sectorOptions);
    })();
  }, [sectorOptions]);

  const ehAdministrador = loggedUserLevel === "Administrador";

  const { inChargeOptions: opcoesDoAdministrador } = useResponsaveis({
    ativo: ehAdministrador,
    urlAdvogados: `management/attorneys/show/all/active/lawsuit/${sessionStorage.getItem("categoria")}/${sessionStorage.getItem("setor")}`,
    urlAssistentes: `management/assistants/show/all/active/lawsuit/${sessionStorage.getItem("setor")}/${sessionStorage.getItem("categoria")}`,
    todos: {
      label: "Todos",
      items: [
        { label: "Todos", value: "global|0" },
        { label: "Todos - exceto estagiários", value: "global|99997" },
        { label: "Todos - exceto assistentes", value: "global|99998" },
        {
          label: "Todos - exceto estagiários e assistentes",
          value: "global|99999",
        },
      ],
    },
  });

  const [opcoesProprias, setOpcoesProprias] = useState<GrupoResponsaveis[]>([]);

  useEffect(() => {
    if (loggedUserLevel === "Advogado" && loggedUserLevelNumber === 2) {
      api.get(`/management/attorneys/show/${loggedUserId}`).then((response) => {
        setOpcoesProprias([
          {
            label: "Advogados",
            items: [
              {
                label: `${response.data.advogado_nome} (Advogado)`,
                value: "adv|".concat(response.data.advogado_id.toString()),
                disabled: false,
                workingsector: response.data.advogado_setor,
              },
            ],
          },
        ]);
        setInCharge(`adv|${loggedUserId}`);
      });
    }

    if (loggedUserLevel === "Assistente" && loggedUserLevelNumber === 2) {
      api
        .get(`/management/administrators/show/${loggedUserId}`)
        .then((response) => {
          setOpcoesProprias([
            {
              label: "Assistentes/Estagiários",
              items: [
                {
                  label: `${response.data.administrador_nome} (Assistente)`,
                  value: "adm|".concat(response.data.administrador_id.toString()),
                  disabled: false,
                  workingsector: response.data.administrador_setor,
                  style: "visibility: hidden",
                },
              ],
            },
          ]);
          setInCharge(`adm|${loggedUserId}`);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const inChargeOptions = ehAdministrador
    ? opcoesDoAdministrador
    : opcoesProprias;

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>
  ) => {
    try {
      // const access = JSON.parse(sessionStorage.getItem('@Jurisnet:access') || '{}');
      const access = JSON.parse(
        localStorage.getItem("@Jurisnet:access") || "{}"
      );

      let menu = "";
      let categoria = 0;
      let setorTxt = "";

      if (access) {
        menu = access.menu;
        categoria = Number(access.categoria);
        setorTxt = access.setor;
      }

      if (user.user_level > 1 && !inCharge) {
        addToast({
          type: "error",
          title: "Selecione o responsável",
          description:
            "Você precisa selecionar o responsável para consultar, caso não esteja selecionado.",
        });
        return;
      }
      const searchFormData = {
        proc_cod_cliente: customerId,
        inCharge,
        referenceId,
        description,
        tipo_horas: hourType,
        proc_tipo: hourType,
        dateFilterType,
        proc_data_ajuiz_inicio: initialRegistrationDate,
        proc_data_ajuiz_final: finalRegistrationDate,
        menu,
        categoria,
        setorTxt,
        doc: "",
      };

      history.push({
        pathname: "/management/workinghour",
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: "error",
        title: "Ocorreu um problema",
        description: "Tente repetir a pesquisa ou contate o administrador.",
      });
    }
  };

  const initialValues: SearchData = {
    proc_cod_cliente: 0,
    inCharge: userTypeDefinition,
    referenceId: 0,
    description: "",
    hourType: "normais",
    proc_tipo: "todos",
    proc_data_ajuiz_inicio: new Date(startOfMonth),
    proc_data_ajuiz_final: new Date(endOfMonth),
  };

  const toDate = (value: string | Date | Date[] | null) =>
    value instanceof Date ? value : null;

  const dateFilterValue: DateFilterValue = {
    mode: dateFilterType === "periodo" ? "periodo" : "data",
    start: toDate(initialRegistrationDate),
    end: toDate(finalRegistrationDate),
  };

  const desfechoFilterValue: DateFilterValue = {
    mode: "data",
    start: toDate(initialDesfechoDate),
    end: toDate(finalDesfechoDate),
  };

  const handleClear = (resetForm: () => void) => {
    setCustomerId("");
    setReferenceId(0);
    setHourType("normais");
    setDescription("");
    setInCharge(userTypeDefinition);
    setDateFilterType("data");
    setInitialRegistrationDate(new Date(startOfMonth));
    setFinalRegistrationDate(new Date(endOfMonth));
    setInitialDesfechoDate(null);
    setFinalDesfechoDate(null);
    resetForm();
  };

  return (
    <Container>
      <FilterStyles>
        <Formik
          onSubmit={handleOnSubmit}
          validationSchema={validationSchema}
          enableReinitialize
          initialValues={initialValues}
        >
          {({ isSubmitting, handleSubmit, handleReset }) => (
            <form className="card search-card" onSubmit={handleSubmit}>
              <header className="search-title">
                <h3>Consulta de horas para {user.name}</h3>
              </header>

              <div className="search-grid">
                <div className="search-col">
                  <Section icon={<LuUsers />} title="Cliente e responsável">
                    <Field id="proc_cliente" label="Cliente">
                      <Dropdown
                        id="proc_cliente"
                        name="proc_cliente"
                        options={customersOptions}
                        onChange={(e) => setCustomerId(e.target.value)}
                        value={customerId}
                        optionLabel="name"
                        optionValue="value"
                        autoFocus
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    {loggedUserLevel === "Administrador" ? (
                      <Field id="inChargeDropDown" label="Responsável">
                        <Dropdown
                          id="inChargeDropDown"
                          name="inChargeDropDown"
                          value={inCharge}
                          options={inChargeOptions}
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          onChange={(e: { value: any }) => setInCharge(e.value)}
                          optionLabel="label"
                          optionGroupLabel="label"
                          optionGroupChildren="items"
                          filter
                          resetFilterOnHide
                          filterBy="label"
                        />
                      </Field>
                    ) : null}
                  </Section>

                  <Section icon={<LuClock />} title="Horas">
                    <div className="row r2">
                      <Field id="proc_cod_adv_resp" label="Referência">
                        <Dropdown
                          id="proc_cod_adv_resp"
                          name="proc_cod_adv_resp"
                          options={referenceOptions}
                          onChange={(e) => setReferenceId(e.target.value)}
                          value={referenceId}
                          optionLabel="name"
                          optionValue="value"
                          filter
                          resetFilterOnHide
                          filterBy="name"
                          placeholder="Selecione uma opção"
                          emptyFilterMessage="Nenhum registro encontrado"
                        />
                      </Field>
                      <Field id="tipo_hora" label="Horas">
                        <SelectButton
                          id="tipo_hora"
                          value={hourType}
                          options={hourTypeOptions}
                          optionLabel="name"
                          onChange={(e) => setHourType(e.value)}
                        />
                      </Field>
                    </div>
                  </Section>
                </div>

                <div className="search-col">
                  <Section icon={<LuCalendarRange />} title="Datas">
                    <DateFilter
                      id="trabalho"
                      label="Data de trabalho"
                      withMode
                      value={dateFilterValue}
                      onChange={(next) => {
                        if (next.mode !== dateFilterType) {
                          setDateFilterType(next.mode);
                          if (next.mode === "data") {
                            setInitialRegistrationDate(new Date(startOfMonth));
                            setFinalRegistrationDate(new Date(endOfMonth));
                          } else {
                            setInitialRegistrationDate(null);
                            setFinalRegistrationDate(null);
                          }
                          return;
                        }
                        setInitialRegistrationDate(next.start);
                        setFinalRegistrationDate(next.end);
                      }}
                    />
                    <DateFilter
                      id="desfecho"
                      label="Data de desfecho"
                      withMode={false}
                      value={desfechoFilterValue}
                      onChange={(next) => {
                        setInitialDesfechoDate(next.start);
                        setFinalDesfechoDate(next.end);
                      }}
                    />
                  </Section>

                  <Section icon={<LuFileText />} title="Descrição">
                    <Field id="description" label="Descrição">
                      <InputTextarea
                        id="description"
                        name="description"
                        value={description || ""}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={3}
                        cols={30}
                      />
                    </Field>
                  </Section>
                </div>
              </div>

              <footer className="search-actions">
                <div className="buttons">
                  <Button
                    type="button"
                    icon="pi pi-undo"
                    label="Limpar campos"
                    className="p-button-outlined p-button-secondary"
                    onClick={() => handleClear(handleReset)}
                  />
                  <Button
                    type="submit"
                    icon="pi pi-search"
                    label="Consultar horas"
                    disabled={isSubmitting}
                  />
                </div>
              </footer>
            </form>
          )}
        </Formik>
      </FilterStyles>
    </Container>
  );
};

export default SearchPendingHour;
